import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateReportDto } from './create-report.dto';

/**
 * Update file DTO
 */
export class UpdateReportDto extends CreateReportDto {
	@TransformInt()
	id!: number;
}
